export default "__VITE_ASSET__ca99bcb9__"